import { Fragment } from "react";

/*
  Room nouns carry `<em>` in JSX, never in the locale value.

  Landing sections render `t()` as a plain text node, so a literal `<em>` in the
  JSON would display as four characters (copy-worksheet.md, Orchestrator ruling
  Q1). The three nouns stay in Latin script and keep their capitals in both
  locales (PRODUCT.md § Terminology), so one split serves `mn` and `en` alike —
  which is why this lives here rather than being written twice, once in the hero
  and once in the rooms comparison.

  Plurals lead the alternation: a regex tries its branches left to right, so
  `String` listed first would take the head off every `Strings`.
*/
const ROOM_NOUNS: readonly string[] = [
  "Loops",
  "Knots",
  "Strings",
  "Loop",
  "Knot",
  "String",
];

const ROOM_NOUN_SPLIT = new RegExp(`(${ROOM_NOUNS.join("|")})`, "g");

/** Splits a translated sentence so every room noun in it renders inside `<em>`. */
export function withRoomNouns(sentence: string) {
  return sentence
    .split(ROOM_NOUN_SPLIT)
    .map((part, i) =>
      ROOM_NOUNS.includes(part) ? (
        <em key={i}>{part}</em>
      ) : (
        <Fragment key={i}>{part}</Fragment>
      )
    );
}
